/**
 * Unified contract for macro Summary cards (Opportunity, tail steps).
 * Every card registers the same three surfaces: row metadata, RBAC field list, value projection.
 */

/** RBAC slice used by Summary filled/total counts */
export type SummaryCardFieldMapping = {
  dataField: string;
  permissionSection: string;
  permissionField: string;
};

/** One visible Summary row */
export type SummaryCardRow = {
  dataField: string;
  permissionSection: string;
  permissionField: string;
  label: string;
  subsection?: string;
  /**
   * Render this row only when the gating field's multi-select selection contains
   * `value`. Evaluated at RENDER time (see isSummaryRowGateSatisfied) — never at
   * row-build time, because the subsection heading rides on the first row.
   * Used by the conditional Smart IT NVL configs (migration 092).
   */
  visibleWhenFieldContains?: { dataField: string; value: string };
};

export type SummaryCardSource = {
  getRowDefinitions: () => ReadonlyArray<SummaryCardRow>;
  getFieldMappings: () => ReadonlyArray<SummaryCardFieldMapping>;
  rowValue: (data: Record<string, unknown>, dataField: string) => string | number | boolean | null | undefined;
};

export const SUMMARY_CARD_IDS = [
  'opportunity',
  'siteInformation',
  'racks',
  'facilityPower',
  'smallUps',
  'coolingReadiness',
  'liquidCooling',
] as const;

export type SummaryCardId = (typeof SUMMARY_CARD_IDS)[number];
